import { KeyValue } from '@angular/common';
import { Injectable } from '@angular/core';
import { CertLogicType, CertRequirementDetail } from '@ats/api/cm';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { startWith } from 'rxjs/operators';

export interface Selection {
	readonly intent?: CertLogicType;
	readonly credential?: number;
	readonly group?: number;
	readonly name?: number;
	readonly overrideGroup?: number;
	readonly overrideName?: number;
}

@Injectable({
	providedIn: 'root',
})
export class CmCreqUploadService {
	selection$: Observable<Selection>;
	selectionSnapshot: Selection = { intent: null, credential: null, group: null, name: null, overrideGroup: null, overrideName: null };
	maps$: Observable<KeyValue<string, string>[]>;
	creqUpload$: Observable<Partial<CertRequirementDetail>>;

	private selectionSubj$ = new BehaviorSubject<Selection>(this.selectionSnapshot);
	private mapsSubj$ = new Subject<KeyValue<string, string>[]>();
	private creqUploadSubj$ = new Subject<Partial<CertRequirementDetail>>();

	constructor() {
		this.selection$ = this.selectionSubj$.asObservable().pipe(startWith(this.selectionSnapshot));
		this.maps$ = this.mapsSubj$.asObservable().pipe(startWith([]));
		this.creqUpload$ = this.creqUploadSubj$.asObservable();
	}

	select(selection: Selection) {
		this.selectionSnapshot = selection;
		this.selectionSubj$.next(selection);
	}

	addMaps(maps: KeyValue<string, string>[]) {
		this.mapsSubj$.next(maps);
	}

	setCReq(creq: Partial<CertRequirementDetail>) {
		this.creqUploadSubj$.next(creq);
	}
}
